"use strict";
// @ts-ignore
try {
    self['workbox:routing:5.1.3'] && _();
}
catch (e) { }
